<template lang="pug">
  #ModalConfirmation
    b-icon(icon="x-circle" style="width: 80px; height: 80px; margin-bottom: 20px;" variant="danger")
    p#title Desactivar Servicio
    p#body ¿Esta seguro que desea desactivar el servicio "{{selected.name}}" para la empresa seleccionada?
    #buttons
      b-button(@click="hideModal" variant="outline-muted" style="margin-right: 20px") Cancelar
      b-button(@click="deactivateService(selected)" variant="danger")
        span Desactivar
</template>
<script>
import { mapActions } from 'vuex';
export default {
  props: ['hideModal', 'selected', 'makeToast'],
  methods: {
    ...mapActions(['editBusinessService']),
    async deactivateService() {
      this.selected.active = !this.selected.active;
      const response = await this.editBusinessService(this.selected);
      if (response.status === 200) {
        this.makeToast("success", "Servicio desactivado.", "Éxito!");
        this.hideModal();
      } else {
        this.makeToast("danger", response.data, "Ocurrió un error!");
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#ModalConfirmation{
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
      margin: 0;
  }

  #title {
    font-size: 24px;
    font-weight: 600;
    color: #323338;
    margin-bottom: 30px;
  }

  #body {
    font-size: 14px;
    color: #7F828F;
    margin-bottom: 30px;
  }

  #buttons {
    align-self: flex-end;
    margin-bottom: 0;
  }
}
</style>